import { render } from "./NotSupportedSnack.vue?vue&type=template&id=385477e8"
import script from "./NotSupportedSnack.vue?vue&type=script&lang=js"
export * from "./NotSupportedSnack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__